import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FilterService } from 'src/app/services/filter.service';
import { FormControl } from '@angular/forms';
import { Subscription, debounceTime } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { CdkOverlayOrigin, FlexibleConnectedPositionStrategyOrigin } from '@angular/cdk/overlay';
import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
    selector: 'widget-new-multi-select',
    templateUrl: './new-multi-select.component.html',
    styleUrls: ['./new-multi-select.component.scss'],
    standalone: false
})
export class DynamicNewMultiSelect extends FieldType implements OnInit, OnDestroy, AfterViewChecked {    //implements OnInit

  @ViewChild('sc') ngSelect!: NgSelectComponent;
  
  override field: any;
  
  dynamicSelect = new FormControl()
  selectedItems: any[] = [];
  label: any
  isOpen: any = null
  selectAllLabel = 'Select All';
  isChecked = false;
  option: any
  opt: any; placeholder: any
  onValueChangeUpdate: any
  dropdownSettings = {}
  dropdownList = []
  itemsShowLimit = 2
  labelProp: any
  valueProp = '';
  reqSubcription: Subscription[] = []
  cardName: any
  cardId: any
  cardPage: any
  statusFromUrl: any
  isCrossed = false
  reasonFromUrl: any;
  showBy: any
  queryFilterData: any
  resetURLData = false;
  addParameter: any;
  isAddChecked = false;
  dashboardKey: any;
  defalutOption: any[] = [];
  previousSelection: any = []
  currentSelection: any = []
  enteredText: any;
  firstTime = true;
  toolTipVisible:any;
  selectAllAsNull=false;
  defaultFilter:any;
  selectAllBtn = true;
  isOpenOverlay = false;
  selectedAll = false;
  selectAllBtnSelected = true;
  defaultAllOption:any=[];
  userCanSelect = 3;
  appliedAll=false;
  noPossible = false;
  serverSideSearch:any;
  serverSideSearchText:any;
  dataSourceUrl:any;
  decomm_flag=false;
  decommReplaceName:any;
  decommColor:any;
  decommlabel:any;
  decommTooltip:any;
  isRootSqBadge = false;
  isGrouped = false;
  groupLabelProp = 'src_category';
  private needsCheckboxUpdate = false;

  // Define a variable to hold the subscription
  private parentControlSubscription: Subscription | undefined;
  trigger!: CdkOverlayOrigin | FlexibleConnectedPositionStrategyOrigin;

  @ViewChild('selectWrapper', { static: false }) selectWrapper!: ElementRef;

  
  constructor(
    public filterService: FilterService,
    private router: Router,
    private route: ActivatedRoute,
    private userActivityService: UserActivityService,
    private navigationService: NavigationService,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient, 
    private apiService: ApiService,
    private mixpanelService: MixpanelService
  ) { super() }

  onOpen() {
    this.needsCheckboxUpdate = true;
    setTimeout(() => {
      const dropdownPanel = this.ngSelect.dropdownPanel(); // Access the dropdown panel
      if (dropdownPanel && dropdownPanel.scrollElementRef) {
        dropdownPanel.scrollElementRef.nativeElement.scrollTop = 0; // Set scroll to top
      }
    });
  }
  shouldDisableDiv(item$: any, index: number): boolean {
    return this.selectedItems.length >= this.userCanSelect && !item$.selected;
  }

  // Excel Filter to get data
  onFilterTextBoxChanged($event: any) {
    this.enteredText = $event.target.value.toLowerCase();
    if(this.enteredText) {
      this.selectAllBtn = false;
      this.noPossible = true;
    } else {
      this.selectAllBtn = true;
      this.noPossible = false;
    }
    
    let option = this.defaultAllOption.filter((f: any) => this.matchesSearch(f, this.enteredText));

    if(option.length==0) {
      this.noPossible = false;
    }

    if(this.enteredText) {
      this.option = _.concat(option, this.selectedItems);
      let combinedOptions = _.concat(option, this.selectedItems);
      this.option = _.uniqBy(combinedOptions, this.labelProp);

      this.isChecked = (this.selectedItems.length == this.option.length) ? true : false;
      return '';
    } else {
      this.option = [...this.defaultAllOption];
      this.isChecked = (this.selectedItems.length == this.option.length) ? true : false;
    }

    
    return ($event.target as HTMLInputElement).value;
  }

  toolTipKey: any;

  // Data present in the drop down or not
  areAllObjectsPresent(array1: any[], array2: any[], property: string): boolean {
    return array1.every(obj1 => array2.some(obj2 => obj2[property] == obj1[property]));
  }
  queryParam: any;
  tabId:any;
  searchByPrescriber:any;
  selectedDashboardKey:any;
  mixPanelConfiguration=false;
  moduleName:any;
  bookmarkId:any;

  ngOnInit() {

    // Route
    this.route.params.subscribe((p: any) => {
      let cardName = p["cardName"];
      this.moduleName = p['module'] || '';

      // Query Params
      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.tabId = params["tab_id"];
        this.dashboardKey = decryptedParams["ds_key"];
        this.cardId = decryptedParams["cardId"] || '';
        
        this.searchByPrescriber = decryptedParams.prescriber || '';

        this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      
        if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
          this.queryFilterData = this.filterService.bookmarkFilterData;
        } else if (cardName || params?.['record'] == 'yes') {
          if (sessionStorage.getItem("filterData")) {
            let filter: any = sessionStorage.getItem("filterData")
            this.queryFilterData = JSON.parse(filter) || {};
          } else {
            this.queryFilterData = '';
          }
        } else {
          this.queryFilterData = '';
        }
      });
    });

    // this.route.params.subscribe((p: any) => {
      // this.cardName = p["cardName"];
      // this.cardId = p["cardId"];

      // this.dashboardKey = p["dashboardKey"];

      // if(sessionStorage.getItem('net_status_flr'))
      // let status:any = sessionStorage.getItem('net_status_flr')
      //   if(status)
      //     this.queryFilterData = JSON.parse(status);
      // // for KPI Control chart
      // if(this.cardName == 'pwt') {

      //   let status:any = sessionStorage.getItem('net_status_flr')
      //   if(status)
      //     this.queryFilterData = JSON.parse(status);
      // } else if (this.cardName == 'recdetail') {
      //   let rec:any = sessionStorage.getItem('rec_detail_flr')
      //   this.queryFilterData = rec ? JSON.parse(rec) : '';
      // } else if(this.cardId=='multi'){

      //   this.route.queryParams.subscribe((r:any)=> {
      //     this.queryFilterData = r ? r : {}
      //   })

      //   // let newData = sessionStorage.getItem('selectedKPIcontrol');
      //   // this.queryFilterData = newData ? JSON.parse(newData)   : '';

      // } else {
      //   this.queryFilterData =  '';
      // }
    // })


    // When Filter is Reseted
    this.reqSubcription.push(this.filterService.formReset.subscribe((res: any) => {
      
      this.queryFilterData = '';
      this.isChecked = false;
      this.isCrossed = true;
      this.resetURLData = true;
      
      this.filterService.previousSelectedItems[this.field.key] = this.option;
      this.filterService.selectedItem['multi'][this.field.key] = this.option;
      this.filterService.allOptionData['multi'][this.field.key] = this.option;
      
      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }
      
      if (this.field?.parentKey == "") {
        this.selectedItems = this.option;
        this.keepConditionBasedSetValue();
      }
      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, 'newMultiSelect', this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
    }), this.filterService.intractiveFilter.pipe(debounceTime(500)).subscribe((res: any) => {
      if (this.field?.key === res.key) {
        // Split the values into an array
        const splitValues = res.value.split('|,|');
        if(res.allNewData.length>0) {
          this.defalutOption = [...res.allNewData];
          this.defaultAllOption = [...res.allNewData];
          this.option = [...res.allNewData];
        }
        // Filter options based on the matching values
        this.selectedItems = [...this.option.filter((item: any) => splitValues.find((o:any)=> o == item[this.field.key]))];
        this.applyFilter(undefined,this.selectedItems);
        this.onClose()
      }
    }))

    this.label = this.field.templateOptions.label
    this.placeholder = this.field.templateOptions.placeHolder
    this.showBy = this.field.templateOptions.showBy
    this.opt = this.field.templateOptions || {};
    let ds = this.opt.dataSourceUrl
    this.dataSourceUrl = this.opt.dataSourceUrl
    this.itemsShowLimit = 2
    this.labelProp = this.opt.labelProp;
    this.valueProp = this.opt.valueProp;
    this.addParameter = this.opt.addParameter;
    this.toolTipKey = this.opt.toolTipVisible || this.labelProp;
    this.selectAllAsNull = true
    this.defaultFilter = this.opt.defaultFilter;
    this.userCanSelect = this.opt.userCanSelect || 100;
    this.serverSideSearch = this.opt?.serverSideSearch == 'yes' ? true : false;
    this.selectedDashboardKey = this.opt.selectedDashboardKey || '';
    this.mixPanelConfiguration = this.opt.mixPanelConfiguration == 'yes' ? true : false;
    this.decomm_flag = this.opt.decomm_flag == 'yes' ? true : false;
    this.decommReplaceName = this.opt.decommReplaceName || 'decomm_flg';
    this.decommColor = this.opt.decommColor || '#c04a36';
    this.decommlabel = this.opt.decommlabel || 'Decomm.';
    this.decommTooltip = this.opt.decommTooltip || 'Decommissioned';
    this.isRootSqBadge = this.opt.isRootSqBadge || false;
    this.groupLabelProp = this.opt.groupLabelProp || this.groupLabelProp;
    this.isGrouped = this.opt.isGrouped || false;

    // Inside your code
    if (this.field?.parentKey != "") {
      (this.field.hooks as any).afterViewInit = (f: any) => {
        const parentControl = this.form.get(this.field.parentKey);
        this.parentControlSubscription = parentControl?.valueChanges.pipe(debounceTime(500)).subscribe((val: any) => {
          let selectedOption = this.model[this.key as string];

          // to empty for child model
          let key = this.key as string
          let fndChild: any = this.filterService.globalFilterFields.find((res: any) => key == res.parentKey)
          if (fndChild) {
            this.model[fndChild.key] = '';
            // User State
            // let ab = { [fndChild.key]: []}
            // this.userActivityService.setData({ "selectedFilters": ab })

            // delete this.filterService.previousSelectedItems?.[fndChild.key]
          }
          // debugger
          if (this.fndParent()) {
            if (ds == "") {
              this.opt.options = val;
              let v = val.find((d: any) => d[this.valueProp] == selectedOption[this.valueProp]);
              this.field.formControl?.setValue(v);
            } else {
              this.loadApiData(this.opt.method || "POST", ds, this.opt.parameter, this.model);
            }
          }
        });
        this.opt.options = [];
      };
    } else {
      this.loadApiData(this.opt.method || "POST", ds, this.opt.parameter, this.model);
    }
  }

  // Is Object or Array
  isObjectNotArray(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  // Find the Parent Key 
  fndParent() {

    let data: any;
    if(this.model[this.field.parentKey]==null) {
      // data = this.model[this.field.parentKey][this.field.parentKey]
      data = this.filterService.selectedItem.multi[this.field.parentKey]
      return data
    } 
    
    if (this.model[this.field.parentKey]?.length) {
      data = this.model[this.field.parentKey].find((r: any) => r[this.field.parentKey])
    } else if (this.isObjectNotArray(this.model[this.field.parentKey])) {
      data = this.model[this.field.parentKey][this.field.parentKey]
    } else if (this.model[this.field.parentKey]) {
    }

    return data
  }

  serverSideSearchFuntion($event:any) {

    this.serverSideSearchText = $event.target.value.toLowerCase();

    if (this.selectedItems.length != this.option.length) {
      this.isChecked = false;
    }
    if(this.serverSideSearchText && this.serverSideSearchText.length>=4) {
      let query:any = this.filterService.serverSideVaribles[this.field.key];
      if(this.field.key == "payer_dim_key") {
        query['payer_search'] = this.serverSideSearchText;
      } else if (this.field.key == "city_name_dim_key") {
        query['city_search'] = this.serverSideSearchText;
      } else if (this.field.key == "group_dim_key") {
        query['group_search'] = this.serverSideSearchText;
      }else if (this.field.key == "practice_dim_key") {
        query['practice_search'] = this.serverSideSearchText;
      }else{
        query['prescriber_search'] = this.serverSideSearchText;
      }
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${this.dataSourceUrl}`, query).subscribe((data: any) => {
          // this.option = data ? [...data] : [];
          this.findtheUniqueFrmSearch(data);
          this.cdr.detectChanges();
          return ($event.target as HTMLInputElement).value;
        }, err => {
          this.option = [];
          console.log('server side search api', err)
          return '';
        })
      )
      // return ''
    }
    
    return ($event.target as HTMLInputElement).value;
  }
  
  storedSearchData:any = [];
  findtheUniqueFrmSearch(data: any[]) {

    const combined = _.concat(this.storedSearchData, data);
    this.storedSearchData = _.uniqBy(combined, this.valueProp);
    
    let defalutOption = _.concat(this.defalutOption, this.storedSearchData);
    this.defalutOption = this.processGroupedData(_.uniqBy(defalutOption, this.valueProp));
    this.defaultAllOption = [...this.defalutOption]

    this.option = [...this.defaultAllOption]

    let option = this.option.filter((f: any) => this.matchesSearch(f, this.serverSideSearchText))
    this.selectedItems = [...option]

    if (this.selectedItems.length == option.length) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }

  }
  
  serverSideSearchFuntionForNavigation() {
    let query:any = this.filterService.serverSideVaribles[this.field.key];
    
    if(this.field.key == "payer_dim_key") {
      query['payer_search'] = this.searchByPrescriber;
    } else if (this.field.key == "city_name_dim_key") {
        query['city_search'] = this.serverSideSearchText;
    } else if (this.field.key == "group_dim_key") {
        query['group_search'] = this.serverSideSearchText;
      }else if (this.field.key == "practice_dim_key") {
        query['practice_search'] = this.serverSideSearchText;
      }else {
      query['prescriber_search'] = this.searchByPrescriber;
    }

    this.reqSubcription.push(
      this.httpClient.post(`${this.apiService.apiBaseUrl}/${this.dataSourceUrl}`, query).subscribe((data: any) => {
        if(data?.length>0) {
          
          let optionData: any = data || [];
          let option: any = data || [];

          const fndPrescriber = option.find((f: any) => this.searchByPrescriber == f[this.field.key]);
          if (fndPrescriber) {
            option = option.filter((f: any) => f[this.field.key] == this.searchByPrescriber);
          }

          if(this.cardName) {
            const payloadData = JSON.parse(sessionStorage.getItem("payloadData") || '{}');
            if (payloadData?.prescriber_id) {
              optionData = option.filter((f: any) => f?.['hcp_dim_key'] === payloadData.prescriber_id);
            }
          }

          this.selectedItems = optionData.length ? optionData : option;
        }
        this.keepConditionBasedSetValue();
      }, err => {
        this.keepConditionBasedSetValue();
      })
    )
  }

  // Load Api
  loadApiData(method: string, url: string, key: string, data: any) {
    this.reqSubcription.push(this.filterService.loadDataNewMultiselection(method, url, key, data, this.selectedDashboardKey=='pare_dashboard'?this.dashboardKey:this.dashboardService.dashboardKey, this.serverSideSearch, this.field.key).subscribe((data: any) => {

      if (data.length > 0) {

        data = this.processGroupedData(data);
        this.option = data ? data : [];
        this.defaultAllOption = data ? data : [];
        
        // Default filter from designer
        if(this.defaultFilter) {
          let spltString = this.defaultFilter.split(',');
          let flrData = this.option.filter((f:any)=> spltString.find((o:any)=> o.toLowerCase() == f[this.key as string].toLowerCase()));
          this.option = [...flrData];
        }

        this.defalutOption = this.option;

        // Back up all data
        this.filterService.backupAllSingleAndMulti[this.field.key] = this.option;

        // Toget selected Source type from the configuration 
        let abcData: any = [];
        let comparedArray: any = [];
        if (this.filterService.selectedFilterValue?.['is_Selected'] == true) {
          abcData = this.filterService.selectedFilterValue['all_source_type'].filter((res: any) => 'source_type' == this.key && res.selected == true)
          if (abcData.length > 0) {
            comparedArray = abcData.filter((obj1: any) => data.some((obj2: any) => obj2[this.key as string].toString() == obj1[this.key as string].toString()));
          }
        }
        // debugger
        if (this.queryFilterData instanceof Array && this.queryFilterData?.length) {
          let selectedData: any = this.queryFilterData.find((o: any) => o.filterKey?.includes(this.field.key));
          if (selectedData) {
            const searchResult = this.option.find((obj: any) => {
              for (let key in obj) {
                if (obj[key].toString().toLowerCase() == selectedData[selectedData.key].toLowerCase()) {
                  return true;
                }
              }
              return false;
            });
            this.queryFilterData = searchResult;
          };
        }

        // from url
        let ifQuery: any;
        if (this.queryFilterData) {
          let queryFilter = Object.entries(this.queryFilterData).map(([key, value]) => ({ key, value }));
          ifQuery = queryFilter.find((fnd: any) => fnd.key == this.field.key)
        }

        // User State
        if (ifQuery && this.queryFilterData && ifQuery?.['value']) {
          let comparedArrayW = this.queryLoaded(ifQuery['value'])
          if (comparedArrayW.length > 0) {
            if (this.cardId == 'multi') {
              this.option = comparedArrayW
              this.selectedItems = comparedArrayW
              this.filterService.allOptionData['multi'][this.field.key] = this.selectedItems
            } else {
              if(this.bookmarkId && !isNaN(Number(this.bookmarkId)) && this.bookmarkId!='config' && this.field.key=='source_type') {
                this.option = comparedArray;
                this.selectedItems = comparedArrayW
                this.filterService.allOptionData['multi'][this.field.key] = this.option
              } else {
                this.selectedItems = comparedArrayW
                this.filterService.allOptionData['multi'][this.field.key] = this.option
              }
            }
          } else {
            this.selectedItems = this.userStoredData();
            this.filterService.allOptionData['multi'][this.field.key] = this.option
          }
        } else {
          if (comparedArray.length > 0) {
            this.option = comparedArray;
            this.selectedItems = this.userStoredData();
          } else {
            this.selectedItems = this.userStoredData();
          }
          this.filterService.allOptionData['multi'][this.field.key] = this.option
        }

        if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
          // User State for only when bookmark ID present
          let ab = { [this.key as string]: this.selectedItems }
          this.userActivityService.setData({ "selectedFilters": ab })

          // user state for single selection
          if (this.cardId == 'multi') {
            let ab = { [this.key as string]: this.selectedItems }
            this.userActivityService.setDataKpiSingle({ "selectedFilters": ab })
          }
        }
        
        if(this.key == 'prescriber_nm' || this.key=='hcp_dim_key' && this.queryFilterData && this.searchByPrescriber) {
          // let key:any  = this.queryFilterData?.[this.field.key];
          
          let fndPrescriber = this.option?.find((f:any)=> this.searchByPrescriber == f?.[this.field.key]);
          if(fndPrescriber) {
            this.option = this.option?.filter((f:any) => f[this.field.key] == this.searchByPrescriber);
            this.selectedItems = this.option;
            this.filterService.allOptionData['multi'][this.field.key] = this.option; 
            this.keepConditionBasedSetValue();
          } else {
            this.serverSideSearchFuntionForNavigation();
          }
        } else {
          this.keepConditionBasedSetValue();
        }

      } else {
        // when there is no data in filter
        this.selectedItems = [];
        this.option = [];
        this.defaultAllOption = [];
        this.isChecked = false;
        // Add Parameter like source key like all the key
        if (this.addParameter) {
          this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
        }
        this.filterService.allOptionData['multi'][this.field.key] = this.option
        this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
        this.filterService.previousSelectedItems[this.field.key] = this.selectedItems

        this.field.formControl?.setValue({ [this.key as string]: 'null' })
        this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, 'newMultiSelect', this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
      }
    }, err => {
      console.error("Error " + err)
      this.selectedItems = []
      this.option = []
      this.defaultAllOption = [];
      this.isChecked = false;
      // Add Parameter like source key like all the key
      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }

      this.filterService.allOptionData['multi'][this.field.key] = this.option
      this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
      this.filterService.previousSelectedItems[this.field.key] = this.selectedItems

      this.field.formControl?.setValue({ [this.key as string]: 'null' })
      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, 'newMultiSelect', this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
    }));
  }

  keepConditionBasedSetValue() {
    // If length is same all should checked
    if (this.selectedItems.length == this.option.length) {
      if(this.defaultAllOption.length==0) {
        this.isChecked = false;
      } else {
        this.isChecked = true;
      }
    } else {
      this.isChecked = false
    }

    this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
    this.filterService.previousSelectedItems[this.field.key] = this.selectedItems

    if(this.selectAllAsNull) {
      this.filterService.selectAllAsNull.push([this.field.key])
    }

    // debugger

    const isAllOptionsDefault = this.option.length === this.defaultAllOption.length;
    
    if (isAllOptionsDefault && this.selectedItems.length === this.option.length) {
      this.appliedAll = true;
      this.isChecked = true;
    }

    if(this.selectedItems.length==this.option.length) {
      this.field.formControl?.setValue(this.selectedItems);
      this.filterService.findSelectedAll[this.valueProp] = true;
      
      // Add Parameter like source key like all the key
      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }

      this.filterService.selectAllNullColumn[this.field.key] = null; 
      this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
      // this.selectedItems = [];
      this.dynamicallyRemoveAllLabel();
      // this.dynamicallyAddAllLabel();
      
      this.selectedAll = true;
      this.selectAllBtnSelected = true;
    } else {
      this.selectedAll = false;
      this.selectAllBtnSelected = false;
      this.filterService.findSelectedAll[this.valueProp] = false;
      this.field.formControl?.setValue(this.selectedItems)

      this.filterService.selectAllNullColumn[this.field.key] = "data";
      // Add Parameter like source key like all the key
      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }

      if(this.selectedItems.length==0) {
        this.filterService.selectAllNullColumn[this.field.key] = null;
      }

      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, 'newMultiSelect', this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
    }
  }

  queryLoaded(query: any) {
    let spltQuery = query.toString().split(',');
    let comparedArrayW = this.option.filter((obj2: any) => spltQuery.some((obj1: any) => obj2[this.field.key].toString().toLowerCase() == obj1.toString().toLowerCase()));
    return comparedArrayW || []
  }
  
  stringifyMode(selectedItems:any, addParameter:any) {
    // debugger
    if (selectedItems?.length == 0) return null;
    // if (selectedItems?.length == this.option.length) return null;

    if (selectedItems?.length == this.option.length && this.option.length == this.defaultAllOption.length) return null;

    let data = ''

    for (let index = 0; index < selectedItems.length; index++) {
      data += selectedItems[index][addParameter] + ','
    }

    return data.slice(0, data.lastIndexOf(","));
  }

  excludeMatchingElements(arr1: any[], arr2: any[]): any[] {
    return arr1.filter((item1: any) => !arr2.some((item2: any) => item2[this.field.key] == item1[this.field.key]));
    // Customize the condition based on the properties you want to compare
  }


  // User State 
  userStoredData() {
    let userStateData: any = this.userActivityService.getData()
    // Object into Array of Object
    let selectedOption: any
    let comparedArray: any = [];

    let updatesObj: any = Object.entries(userStateData.selectedFilters).map(([key, value]) => ({ key, value }));
    let findData: any = updatesObj?.find((o: any) => o.key == this.key as string)


    if (findData) {
      if (findData.value.length) {

        comparedArray = findData['value']?.filter((obj1: any) => this.option.some((obj2: any) => obj2[this.key as string].toString() == obj1[this.key as string].toString()));
        if (comparedArray.length > 0) {
          selectedOption = comparedArray
        } else {
          selectedOption = this.option
        }
      } else {
        selectedOption = this.findObjectsById(findData.value[this.key as string])
      }
    } else {
      selectedOption = this.option;
    }
    return selectedOption
  }

  // Find Data using by ID
  findObjectsById(idToFind: any) {
    let myArray: any = []
    let selectedOption: any
    let fnd = this.option.find((o: any) => o[this.key as string] == idToFind)

    if (fnd) {
      myArray.push(fnd)
      selectedOption = myArray
    } else {
      selectedOption = this.option
    }

    return selectedOption
  }

  // Set Previous to get from service
  setPreviousItems() {
    this.filterService.previousSelectedItems[this.field.key] = this.selectedItems
    this.isChecked = (this.selectedItems.length == this.option.length)
    this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
  }

  // Select All function
  selectAll() {
    this.selectedItems = []
    if (this.isChecked)
      this.option.map((o: any) => this.selectedItems.push(o));
    // if (this.selectedItems)
    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
  }

  selectAllClick() {

    this.isChecked = !this.isChecked
    this.isAddChecked = false;
    this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    // this.excelBasedFilter()
    setTimeout(() => {

    if(this.isChecked) {
      this.selectedItems = [...this.option]
    } else {
      this.selectedItems = [];
    }
    

    if(this.option.length==this.selectedItems.length) {
      this.selectedAll = true;
      this.selectAllBtnSelected = true;
      // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option)
    } else {
      if(this.selectedItems.length==0) {
        this.selectedAll = true;
        this.selectAllBtnSelected = true;
        // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option)
      } else {
        this.selectedAll = false;
        this.selectAllBtnSelected = false;
        // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
      }
    }
    
    // Use a debounce or throttle approach for change detection
    
      if (this.selectedItems.length === 0) {
        this.dynamicallyAddAllLabel();
      } else {
        this.dynamicallyRemoveAllLabel();
      }
      this.cdr.detectChanges();
    }, 0);
  }

  dynamicallyRemoveAllLabel() {
    const existingDiv = document.getElementById('du-subash-multi-select-id'+this.valueProp);
    if (existingDiv) {
      existingDiv.remove();
    }
  }

  dynamicallyAddAllLabel() {
    const container = document.getElementById('du-ng-select' + this.valueProp);
    let newId = "du-subash-multi-select-id"+this.valueProp;

    if (container) {
      const existingDiv = container.querySelector(`#${newId}`);
  
      if (existingDiv) {
        // If the div exists, remove it
        existingDiv.remove();
      } else {
        // Create a new div element
        const parentDiv = document.createElement('div');
        parentDiv.id = newId;
        parentDiv.classList.add('ng-value', 'du-subash-multi-select');
        const childDiv = document.createElement('span');
        childDiv.classList.add('ng-value-label');
        childDiv.textContent = 'All';
        parentDiv.appendChild(childDiv);
  
        const nestedDiv: any = container.querySelector('.ng-value-container');
        if (nestedDiv) {
          const ngInputDiv = nestedDiv.querySelector('.ng-input');
          if (ngInputDiv) {
            nestedDiv.insertBefore(parentDiv, ngInputDiv);
          }
        }
      }
    }
  }
  // Possible Selection
  possibleSelection() {
    
    this.selectAllBtnSelected = false;
    this.selectedAll = false;
    
    if(this.enteredText) {
      let option = this.defaultAllOption.filter((f: any) => f[this.labelProp].toString().toLowerCase().includes(this.enteredText?.toString().toLowerCase()));
      
      if(option.length>0) {
        if(this.selectedItems.length==0 || this.defaultAllOption.length==option.length) {
          this.selectedItems = [...option];
        } else {
          option.forEach((m: any) => {
            const exists = this.selectedItems.some((f: any) => f[this.valueProp] === m[this.valueProp]);
            if (!exists) {
              this.selectedItems.push(m);
            }
          });
        }
      }
    }
    
    if(this.defaultAllOption.length==this.selectedItems.length) {
      this.dynamicallyRemoveAllLabel();
      this.selectAllBtnSelected = true;
      this.selectedAll = true;
    } else {
      if(this.selectedItems.length==0) {
        this.dynamicallyAddAllLabel();
        this.selectedAll = true;
        this.selectAllBtnSelected = true;
      } else {
        this.dynamicallyRemoveAllLabel();
      }
    }
  }

  selectAlternative() {
    // debugger
    if(this.selectedItems.length!=this.option) {
      const alterData = this.option.filter((f: any) => !this.selectedItems.find((o: any) => o[this.labelProp] === f[this.labelProp]));
      this.selectedItems = [];
      this.selectedItems = [...alterData];
    }
  }

  selectExcluded() {
    if(this.selectedItems.length!=this.option) {
      const alterData = this.option.filter((f: any) => !this.selectedItems.find((o: any) => o[this.labelProp] === f[this.labelProp]));
      this.selectedItems = [];
      this.selectedItems = [...alterData];
    }
  }

  // Select Add CLick in Excel Filter
  selectAddClick() {
    this.isAddChecked = !this.isAddChecked

    let previousSelect: any = this.filterService.previousSelectedItems[this.field.key]
    if (this.isAddChecked) {
      if (previousSelect.length > 0) {
        this.selectedItems = previousSelect.concat(this.selectedItems);
        this.selectedItems = this.removeDublicates(this.selectedItems);
        this.selectedItems = this.option.filter((f:any)=> this.selectedItems.find((o:any)=> o[this.labelProp] == f[this.labelProp]))
        
      }
    } else {
      this.selectedItems = this.removeSelectedObjects(this.selectedItems, previousSelect);
      this.selectedItems = this.removeDublicates(this.selectedItems)
    }
    if (this.selectedItems.length == 0) {
      this.isChecked = false;
    }

    if((this.option.length==this.selectedItems.length)&& (this.defalutOption.length == this.option.length)) {
      this.selectedAll = true;
      this.dynamicallyRemoveAllLabel();
      this.selectAllBtnSelected = true;
      this.isChecked = true;
      // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option)
    } else {
      if(this.selectedItems.length==0) {
        this.selectedAll = true;
        this.dynamicallyAddAllLabel();
        this.selectAllBtnSelected = true;
        // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option)
      } else {
        this.selectedAll = false;
        this.dynamicallyRemoveAllLabel();
        this.selectAllBtnSelected = false;
        this.isChecked = false;
        // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
      }
    }


  }

  // Excel Based Filter
  excelBasedFilter() {
    if (this.enteredText) {
      let option = this.option.filter((f: any) => f[this.labelProp].toString().toLowerCase().includes(this.enteredText))
      if (this.isChecked) {
        this.selectedItems = [...option];
      } else {
        this.selectedItems = []
      }
    } else {
      this.selectedItems = [];
      if (this.isChecked) {
        this.selectedItems = [...this.option]
      }
    }

    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
  }

  removeSelectedObjects(mainArray: any[], objectsToRemove: any[]): any[] {
    return mainArray.filter(obj => !objectsToRemove.some(remObj => remObj[this.field.key].toString().toLowerCase() == obj[this.field.key].toString().toLowerCase()));
  }

  removeDublicates(data: any) {
    return Array.from(new Set(data.map((item: any) => item[this.field.key]))).map(id => {
      return data.find((item: any) => item[this.field.key] === id);
    });
  }

  disabledOption() {
    if(this.selectedItems.length >= this.userCanSelect) {
      this.option = _.map(this.option, item => {
        
        if(this.selectedItems.length==0) return _.assign({}, item, { disabled: false });
        
        const selectedItem = this.selectedItems.find((f:any)=> f[this.labelProp] == item[this.labelProp]);
        if(selectedItem) {
          return _.assign({}, item, { disabled: false });
        } else {
          return _.assign({}, item, { disabled: true });
        }
      });
    } else {
      this.option = _.map(this.option, item => _.assign({}, item, { disabled: false }));
    }
  }

  selectOption() {

    this.needsCheckboxUpdate = true;
    this.selectAllLabel = 'Select All';
    this.dynamicallyRemoveAllLabel();

    if(this.option.length==this.defaultAllOption.length) {
      if(this.option.length==this.selectedItems.length) {
        this.selectedAll = true;
        this.isChecked = true;
      } else {
        this.selectedAll = false;
        this.isChecked = false;
      }
    } else {
      this.isChecked = false;

      if(this.selectedItems.length==0) {
        this.selectedAll = true;
        this.isAddChecked = false;
      } else {
        this.selectedAll = false;
      }
    }

    // // Disabled Functions
    // // this.disabledOption();

    // // this.isChecked = (this.selectedItems.length == this.option.length)
    // this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    // // if (this.selectedItems.length == 0)
    // //   this.isOpen = true;
    // // else
    // //   this.isOpen = null

    // if(this.option.length==this.selectedItems.length) {
    //   this.selectedAll = false;
    //   this.isChecked = true;
    //   this.dynamicallyRemoveAllLabel();

    //   if(this.selectedItems.length != this.defalutOption.length) {
    //     this.isChecked = false;
    //     this.dynamicallyRemoveAllLabel();
    //   }
    //   // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp)
    //   // this.selectAllBtnSelected = true;
    // } else {
    //   if(this.selectedItems.length==0) {
    //     this.dynamicallyAddAllLabel()
    //     this.selectedAll = true;
    //     this.isChecked = false;
    //     this.isAddChecked = false;
    //     // this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option)
    //     // this.selectAllBtnSelected = true;
    //   } else {
    //     this.isChecked = false;
    //     this.selectedAll = false;
    //     this.dynamicallyRemoveAllLabel()
    //     this.selectAllBtnSelected = false;
    //     // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
    //   }
    // }

    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
  }

  getDifference(array1: any, array2: any) {
    return array1.filter(
      (object1: any) => !array2.some(
        (object2: any) => object1[this.key as string] == object2[this.key as string]
      ),
    );
  }

  getDeSelectedData(): any {
    const data: any = sessionStorage.getItem('deSelectedFilter');
    return JSON.parse(data) || this.deSelectedData;
  }

  deSelectedData: any = {
    'deSelect': {}
  }

  differenceOfDetails(data: any) {
    this.deSelectedData = this.getDeSelectedData();

    // Object into Array of Object
    let updatesObj: any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for (let i = 0; i < updatesObj.length; i++) {
      if (updatesObj[i].key == "deSelect") {
        let Obj: any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res: any) => {
          this.deSelectedData[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.deSelectedData[updatesObj[i].key] = updatesObj[i].value
      }
    }

    const serializedData: any = JSON.stringify(this.deSelectedData);
    sessionStorage.setItem('deSelectedFilter', serializedData);

  }

  applyFilter(ctrl?: any,selectedItems?:any) {

    let key = this.key as string
    let fndChild: any = this.filterService.globalFilterFields.find((res: any) => key == res.parentKey)

    this.selectedItems = selectedItems || this.selectedItems
    if (fndChild) {
      this.model[fndChild.key] = ''

      // User State
      let ab = { [fndChild.key]: [] }
      this.userActivityService.setData({ "selectedFilters": ab })

      delete this.filterService.previousSelectedItems?.[fndChild.key]
    }

    this.navigationService.filterSingleState(key);
    
    this.setPreviousItems();
    this.isOpen = null

    
    // User State
    let ab = { [this.key as string]: this.selectedItems }
    this.userActivityService.setData({ "selectedFilters": ab })

    // user state for single selection
    if (this.cardId == 'multi') {
      let ab = { [this.key as string]: this.selectedItems }
      this.userActivityService.setDataKpiSingle({ "selectedFilters": ab })
    }

    // from network chart => status code and patient status
    let netWork: any = sessionStorage.getItem('net_status_flr')
    if (netWork) {
      netWork = JSON.parse(netWork)

      let updatesObj: any = Object.entries(netWork).map(([key, value]) => ({ key, value }));
      let findData: any = updatesObj.find((o: any) => o.key == key)

      if (findData) {
        delete netWork[findData.key]
        sessionStorage.setItem('net_status_flr', JSON.stringify(netWork))
      }
    }

    //  // KPI Break Down
    // let kpiCon:any = sessionStorage.getItem('selectedKPIcontrol')

    // if(kpiCon) {
    //   kpiCon = JSON.parse(kpiCon)

    //   let updatesObj: any = Object.entries(kpiCon).map(([key, value]) => ({ key, value }));
    //   let findKpi: any = updatesObj.find((o: any) => o.key == key)

    //   if(findKpi) {
    //     delete kpiCon[findKpi.key]
    //     sessionStorage.setItem('selectedKPIcontrol', JSON.stringify(kpiCon))
    //   }
    // }

    this.filterService.filterApplyBtn();

    this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems;
    
    if(this.mixPanelConfiguration) {
      let mixPanel = this.moduleName + ' - ' + this.dashboardService.dashboardName + ' - ' + this.label + ' - ' + 'Filter';
      this.mixpanelService.track(mixPanel);

    }
    
    if (!this.serverSideSearch && this.selectedItems.length === this.option.length) {
      this.appliedAll = true;
      this.updateSelectionState(null, 'All');
    } else {
      this.selectAllLabel = 'Select All';
      this.dynamicallyRemoveAllLabel();
    
      const isAllOptionsDefault = this.option.length === this.defaultAllOption.length;
    
      if (isAllOptionsDefault && this.selectedItems.length === this.option.length) {
        this.appliedAll = true;
        this.updateSelectionState(null, 'All');
      } else if (this.selectedItems.length === 0) {
        this.appliedAll = false;
        this.updateSelectionState(null, 'All');
        this.field.formControl?.setValue(this.option);
      } else {
        this.appliedAll = false;
        this.updateSelectionState('data', this.selectedItems.length);
      }
    }
    console.log(this.selectedItems.length);
    
    ctrl?.close();
  
  }

  applyIncludeExcludeFilter(type: any, ctrl?: any) {
    const all = [...this.option];              // master list
    const selected = [...this.selectedItems];  // user selections

    if (type === 'include') {

      // if (!this.isAddChecked) {
        this.selectedItems = all.filter(opt =>
          selected.some(sel => sel[this.valueProp] === opt[this.valueProp])
        );
      // }

    } else if (type === 'exclude') {

      this.selectedItems = all.filter(opt =>
        !selected.some(sel => sel[this.valueProp] === opt[this.valueProp])
      );

    } else {

      this.selectedItems = [...all];

    }

    this.applyFilter(ctrl);
  }
  
  updateSelectionState(nullColumnValue: any, badgeValue: any) {
    this.field.formControl?.setValue(this.selectedItems);

    this.filterService.findSelectedAll[this.valueProp] = this.selectedItems.length === this.option.length && this.option.length === this.defaultAllOption.length;
    this.filterService.selectAllNullColumn[this.field.key] = nullColumnValue;
  
    if (this.addParameter) {
      this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter);
    }
  
    this.filterService.setBadgeValue(this.key as string, badgeValue, 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData());
  }

  // drop down close to get details
  onClose() {
    if(this.defaultAllOption.length==0) return;

    this.firstTime = true;
    this.isAddChecked = false;
    this.enteredText = '';
    this.serverSideSearchText = '';
    this.option = [...this.defalutOption];
    this.selectAllBtn=true;

    if (this.filterService.previousSelectedItems?.[this.field.key].length == 0) {
      this.isChecked = true
      this.selectedItems = this.option
    } else {
      this.selectedItems = this.filterService.previousSelectedItems?.[this.field.key]
      this.isChecked = (this.selectedItems.length == this.option.length)
      this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    }

    if(this.option.length == this.selectedItems.length) {
      
      if(!this.appliedAll) {
        this.isChecked = false;
        this.selectedItems = [];
        this.dynamicallyRemoveAllLabel();
        this.dynamicallyAddAllLabel();
      } else {
        this.dynamicallyRemoveAllLabel();
        this.isChecked = true;
      }

      this.selectedAll = true;
      this.selectAllBtnSelected = true;
      this.filterService.setBadgeValue(this.key as string, 'All', 'newMultiSelect', this.option, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
    } else {
      this.selectedAll = false;
      this.selectAllBtnSelected = false;
      this.dynamicallyRemoveAllLabel();
      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, 'newMultiSelect', this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option, this.field, undefined, this.groupBadgeData())
    }
  }

  overlayClick(event: MouseEvent) {
    event.stopPropagation();  // Prevent the click from closing the ng-select
  }

  // Grouping details passed to the filter badge
  groupBadgeData() {
    return { isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp };
  }

  // Search matches the option label, its group name, or its decomm tag label
  matchesSearch(item: any, text: any): boolean {
    const term = (text || '').toString().toLowerCase();
    const texts = [item?.[this.labelProp]];
    if (this.isGrouped) {
      texts.push(item?.[this.groupLabelProp]);
    }
    if (this.decomm_flag && item?.[this.decommReplaceName] == 'Y') {
      texts.push(this.decommlabel);
    }
    return texts.some((t: any) => t !== null && t !== undefined && t.toString().toLowerCase().includes(term));
  }

  // ng-select's own list filter, so the visible options match the same way
  searchFn = (term: string, item: any) => this.matchesSearch(item, term);

  // Process data for grouping
  processGroupedData(data: any[]) {
    if (this.isGrouped) {
      // Ungrouped items first, then grouped items
      const ungroupedItems = data.filter(item => item[this.groupLabelProp] === null || item[this.groupLabelProp] === undefined);
      const groupedItems = data.filter(item => item[this.groupLabelProp] !== null && item[this.groupLabelProp] !== undefined);
      return [...ungroupedItems, ...groupedItems];
    }
    return data;
  }

  // Get group value from group object or string
  getGroupValue(groupValue: any): string {
    if (typeof groupValue === 'object' && groupValue !== null) {
      return groupValue[this.groupLabelProp] || '';
    }
    return groupValue || '';
  }

  // Id of the group header checkbox, scoped per filter
  getGroupCheckboxId(groupValue: any): string {
    return 'group-checkbox-' + this.valueProp + '-' + (this.getGroupValue(groupValue) || 'ungrouped');
  }

  // Get items by group
  getItemsByGroup(groupValue: any): any[] {
    const targetGroupValue = this.getGroupValue(groupValue);
    return this.option.filter((item: any) => {
      const itemGroupValue = item[this.groupLabelProp];
      if (!targetGroupValue) {
        return !itemGroupValue;
      }
      return itemGroupValue === targetGroupValue;
    });
  }

  // Get checkbox state for group
  getGroupCheckboxState(groupValue: any): 'checked' | 'indeterminate' | 'unchecked' {
    const groupItems = this.getItemsByGroup(groupValue);
    if (groupItems.length === 0) return 'unchecked';

    const selectedCount = groupItems.filter((item: any) =>
      this.selectedItems.some((selected: any) => selected[this.valueProp] === item[this.valueProp])
    ).length;

    if (selectedCount === 0) return 'unchecked';
    if (selectedCount === groupItems.length) return 'checked';
    return 'indeterminate';
  }

  // Check if all items in a group are selected
  isGroupSelected(groupValue: any): boolean {
    return this.getGroupCheckboxState(groupValue) === 'checked';
  }

  // Handle click on group header
  onGroupDivClick(groupValue: any, event: any): void {
    // Stop propagation to prevent ng-select from closing
    event.stopPropagation();
    event.preventDefault();

    const groupItems = this.getItemsByGroup(groupValue);

    if (this.isGroupSelected(groupValue)) {
      // Deselect all items in the group
      this.selectedItems = this.selectedItems.filter((selected: any) =>
        !groupItems.some((item: any) => item[this.valueProp] === selected[this.valueProp])
      );
    } else {
      // Select all items in the group that aren't already selected
      const newItems = groupItems.filter((item: any) =>
        !this.selectedItems.some((selected: any) => selected[this.valueProp] === item[this.valueProp])
      );
      this.selectedItems = [...this.selectedItems, ...newItems];
    }

    this.needsCheckboxUpdate = true;
    this.selectOption();
  }

  // Update group checkbox indeterminate states after view is checked
  ngAfterViewChecked(): void {
    if (this.needsCheckboxUpdate && this.isGrouped) {
      this.updateGroupCheckboxStates();
      this.needsCheckboxUpdate = false;
    }
  }

  updateGroupCheckboxStates(): void {
    if (!this.option || this.option.length === 0) return;

    const groupValues = new Set<string>();
    this.option.forEach((item: any) => groupValues.add(item[this.groupLabelProp] || ''));

    groupValues.forEach(groupValue => {
      const checkbox = document.getElementById(this.getGroupCheckboxId(groupValue)) as HTMLInputElement;
      if (checkbox) {
        checkbox.indeterminate = (this.getGroupCheckboxState(groupValue) === 'indeterminate');
      }
    });
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
    if (this.parentControlSubscription) {
      this.parentControlSubscription.unsubscribe();
    }
  }
}